import { DEVEXTREME_LICENSE_KEY } from "@bds/devextreme-license";
export const DevExtremeLicenseProvider = {
    provide: DEVEXTREME_LICENSE_KEY,
    useValue: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImEzNDg5ZWM0LTVmZTgtNDgwOS1hZWYxLWMyYzkwNjNkNWU3YiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.eSQ8ndRel43mAz2rGFwKrBZl5eWzbiWk90GZNJ5iq0m9svFAJMvIo3gHFUjoghPoJeXVEfmtrtycOgehbv1UHb4186LGiE6syIynOHdJR20aRQ//UxOBQvFbjo75B0tHAo3Bpg=='
};
